import { useEffect, useRef, useState } from 'react';
import EcoSpace from 'eco-design/base/eco-space';
import css from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import useDeviceDetect from '@/utils/hooks/useDeviceDetect';
import EcoVideo from 'eco-design/base/eco-video';

const Roof: React.FC = () => {
    const { t } = useLang('shp3');
    const { isPad, isH5 } = useDeviceDetect();
    const infoRef = useRef<HTMLDivElement>(null);
    const [video, setVideo] = useState('');
    useEffect(() => {
        const label = infoRef.current?.querySelector('.label');
        const title = infoRef.current?.querySelector('.title');
        const desc = infoRef.current?.querySelector('.desc');
        const video = document.querySelector('.shp3-F .eco-video');
        const ani1 = AniContainer.create({
            triggerElement: infoRef.current,
            triggerHook: 1,
            offset: '20%',
            duration: '100%',
            onEnter: () => {
                label?.classList.add('enter');
                title?.classList.add('enter');
                desc?.classList.add('enter');
                video?.classList.add('enter');
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    label?.classList.remove('enter');
                    title?.classList.remove('enter');
                    desc?.classList.remove('enter');
                    video?.classList.remove('enter');
                }
            },
        });
        const ani2 = AniContainer.create({
            triggerElement: '.shp3-E',
            triggerHook: 1,
            onEnter: () => setVideo('https://websiteoss.ecoflow.com/upload/video/1761290399218/03_Priority_SPH3_1.mp4'),
        });
        return () => {
            ani1.destroy?.();
            ani2.destroy?.();
        };
    }, []);
    return (
        <>
            <EcoSpace />
            <section
                className={`${css.section} shp3-F GtmModuleData-section`}
                id="shp3-F"
                data-section-id={'shp3-F'}
                data-section-title={t('title')}
                // ref={sectionRef}
            >
                <div className="info" ref={infoRef}>
                    <div className="left">
                        <div className="label ani-1">{t('F_label')}</div>
                        <div className="title ani-2">{t('F_title')}</div>
                    </div>
                    <div className="desc right ani-2-5">
                        {t.rich('F_desc', {
                            h: (a: string) => {
                                return <span className="white">{a}</span>;
                            },
                        })}
                    </div>
                </div>

                <div className="eco-video ani-3">
                    {video && (
                        <video
                            className="video"
                            src={video}
                            autoPlay
                            loop
                            muted
                            preload="metadata"
                            poster={
                                isPad || isH5
                                    ? 'https://websiteoss.ecoflow.com/upload/image/1760171004882/m_When%20the%20Storm%20Hits_%20Lights%20Stay%20On%20(1).jpg'
                                    : 'https://websiteoss.ecoflow.com/upload/image/1760170628917/pc_When%20the%20Storm%20Hits_%20Lights%20Stay%20On.jpg'
                            }
                            width="100%"
                            height="100%"
                            playsInline
                            aria-label={t('F_title')}
                        />
                    )}
                </div>
            </section>
        </>
    );
};

export default Roof;
